/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Github_P1Inputs */

const en_contact_github_p1 = /** @type {(inputs: Contact_Github_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Found a bug or have a feature request? Opening an issue on the GitHub repository is often the fastest way to get it tracked, and it lets other users follow along. The full source of this site is in that repository.`)
};

const ko_contact_github_p1 = /** @type {(inputs: Contact_Github_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`버그를 발견했거나 기능 요청이 있다면 GitHub 저장소에 이슈를 등록하는 것이 가장 빠릅니다. 다른 사용자도 진행 상황을 함께 볼 수 있습니다. 이 사이트의 전체 소스가 그 저장소에 있습니다.`)
};

const ja_contact_github_p1 = /** @type {(inputs: Contact_Github_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バグを見つけた、または機能のご要望がある場合は、GitHub リポジトリで issue を作成するのが最も早い方法です。ほかの利用者も経過を追えます。このサイトの全ソースはそのリポジトリにあります。`)
};

/**
* | output |
* | --- |
* | "Found a bug or have a feature request? Opening an issue on the GitHub repository is often the fastest way to get it tracked, and it lets other users follow a..." |
*
* @param {Contact_Github_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const contact_github_p1 = /** @type {((inputs?: Contact_Github_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Github_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact_github_p1(inputs)
	if (locale === "ko") return ko_contact_github_p1(inputs)
	return ja_contact_github_p1(inputs)
});